import { CURSOR_OVER } from '../../../constants/Constants';

export class StarBreathingInput extends Phaser.Events.EventEmitter {
  constructor(scene, pathTrailStar) {
    super();
    this.scene = scene;
    this.isDesktop = this.scene.game.device.os.desktop;
    this.pathTrailStar = pathTrailStar;
    this.desktopEnabled = false;
  }

  enable() {
    if (this.isDesktop) {
      if (this.desktopEnabled) {
        this.addListenerhandleTrailStarSelect();
      } else {
        this.desktopEnabled = true;
        this.pathTrailStar.setInteractive({ cursor: CURSOR_OVER });
        this.pathTrailStar.on('pointerdown', this.addListenerhandleTrailStarSelect, this);
      }
    } else {
      this.scene.input.on('pointerdown', this.handlePointerDown, this);
      this.scene.input.on('gameout', this.handlePointerUp, this);
      this.scene.input.on('pointerup', this.handlePointerUp, this);
    }
  }

  disable() {
    this.pathTrailStar.removeInteractive();
    this.pathTrailStar.off('pointerdown', this.addListenerhandleTrailStarSelect, this);
    this.scene.input.off('pointerdown', this.handlePointerDown, this);
    this.scene.input.off('gameout', this.handlePointerUp, this);
    this.scene.input.off('pointerup', this.handlePointerUp, this);
    this.scene.input.off('pointermove', this.handlePointerMove, this);
  }

  addListenerhandleTrailStarSelect() {
    this.mouseLast = { x: this.scene.input.activePointer.x, y: this.scene.input.activePointer.y };
    this.scene.input.on('pointermove', this.handlePointerMove, this);
  }

  // INPUT EVENTS
  handlePointerDown(e) {
    this.mouseLast = { x: e.x, y: e.y };
    this.scene.input.on('pointermove', this.handlePointerMove, this);
    this.emit('pointerdown');
  }

  handlePointerMove(e) {
    const distance = Phaser.Math.Distance.BetweenPoints(this.mouseLast, e);
    const angle = Phaser.Math.Angle.BetweenPoints(this.mouseLast, e);
    this.mouseLast = { x: e.x, y: e.y };
    this.emit('move', { angle, distance });
  }

  handlePointerUp(e) {
    this.scene.input.off('pointermove', this.handlePointerMove, this);
    this.emit('pointerup');
  }

  destroy() {
    this.disable();
  }
}
